// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 926) return "static/chunks/926-ba5252434e812a7b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"481":"dd706f664c1f7c31","662":"97f7a14ce4a7d745"}[chunkId] + ".js";
};